// extracted by mini-css-extract-plugin
export var activeLink = "menu-module--activeLink--efb69";
export var activeWrapper = "menu-module--activeWrapper--a1b02";
export var link = "menu-module--link--5c73e";
export var navigation = "menu-module--navigation--9a805";
export var socialLink = "menu-module--socialLink--d5b9e";
export var wrapper = "menu-module--wrapper--280e2";